import { getScreenName } from '../helper';

import { fireEvent } from '../fireEvent';

export const viewedAndroidLanding = (productId) => {
  fireEvent({
    category: 'viewed_landing_by_android',
    screen_name: getScreenName(),
    id: productId,
  });
};
